import { render, staticRenderFns } from "./WarehouseListTable.vue?vue&type=template&id=654d5bca"
import script from "./WarehouseListTable.vue?vue&type=script&lang=js"
export * from "./WarehouseListTable.vue?vue&type=script&lang=js"
import style0 from "./WarehouseListTable.vue?vue&type=style&index=0&id=654d5bca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports